<mat-expansion-panel expanded = true>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Assigned Users
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ul class="assigned-users-container">
    <!-- XCT-E-591-05: each holder's row and its Remove button, keyed by email, so a script can take one person off the role -->
    <li *ngFor="let user of platformUsers" [attr.data-cy]="'assigned-user_' + user.email">
      <div class="assigned-users">
        <div class="flex flex-row flex-wrap items-center justify-start avatar-container">
          <ngx-stored-gravatar
            [name]="user.name"
            [email]="user.email"
            [hideOnlineStatus]="true"
            [style]="defaultStyle"
          >
          </ngx-stored-gravatar>
          <div class="flex  flex-col items-start justify-start content">
            <div>{{user.fullName}}</div>
            <div class="tag">{{user.email}}</div>

          </div>
        </div>
        <button
          [disabled]="currentUserEmail === user.email && roleModelId === defaultRolesId.Administrator"
          mat-button type="delete"
          [attr.data-cy]="'assigned-user-remove_' + user.email"
          (click)="onRemoveUser(user)"
        >Remove</button>
      </div>
    </li>
  </ul>
</mat-expansion-panel>
